import { useEffect } from 'react';

export const useScrollTo = ({ errors, submitCount, isSubmitting, isValid }, callback = null) => {
  useEffect(() => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0 && submitCount > 0 && isSubmitting && !isValid) {
      const firstError = errorKeys[0];
      if (firstError && document.getElementById(firstError)) {
        window.scrollTo({
          behavior: 'smooth',
          left: 0,
          top: document.getElementById(firstError).getBoundingClientRect().top
        });
        if (callback) {
          callback(errorKeys.length, errors);
        }
      } else if (callback) {
        // If no element found to scroll to, still show the error toast
        callback(errorKeys.length, errors);
      }
    }
  }, [errors, submitCount, isValid]);
};
